// @flow
import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILED,
  LOGOUT_USER,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_FAILED,
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_FAILED,
  SET_USER,
  GET_ME,
  SET_PENDUDUK,
  SET_DESA,
  ACCESS_BLOCKED,
  HANDLE_ERROR,
  GET_ME_FAILED,
  SET_SUMMARY_DATA,
  SET_LOADING,
} from "./constants";

import { getAuthToken } from "../../helpers/authUtils";

const INIT_STATE = {
  token: getAuthToken(),
  loading: false,
  user: null,
  auth: false,
  blocked: false,
  redirect: null,
  desa: null,
  summary_data: null,
};

type AuthAction = { type: string, payload: {} | string };
type State = { token?: {} | null, loading?: boolean, +value?: boolean };

const Auth = (state: State = INIT_STATE, action: AuthAction) => {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state, loading: true };
    case LOGIN_USER_SUCCESS:
      return {
        ...state,
        token: action.payload,
        loading: false,
        error: null,
        auth: true,
      };
    case LOGIN_USER_FAILED:
      return { ...state, error: action.payload, loading: false };
    case HANDLE_ERROR:
      return { ...state, token: null, user: null, redirect: null };
    case REGISTER_USER:
      return { ...state, loading: true };
    case REGISTER_USER_SUCCESS:
      return {
        ...state,
        token: action.payload,
        loading: false,
        error: null,
        auth: true,
      };
    case REGISTER_USER_FAILED:
      return { ...state, error: action.payload, loading: false };
    case LOGOUT_USER:
      return { ...state, token: null, user: null, redirect: null };
    case FORGET_PASSWORD:
      return { ...state, loading: true };
    case FORGET_PASSWORD_SUCCESS:
      return {
        ...state,
        passwordResetStatus: action.payload,
        loading: false,
        error: null,
      };
    case FORGET_PASSWORD_FAILED:
      return { ...state, error: action.payload, loading: false };
    case GET_ME:
      return { ...state, loading: true, auth: true };
    case SET_USER:
      return { ...state, user: action.payload, loading: false };
    case SET_PENDUDUK:
      return { ...state, user: action.payload, loading: false };
    case SET_DESA:
      return {
        ...state,
        desa: { ...state.desa, ...action.payload },
      };
    case ACCESS_BLOCKED:
      return {
        ...state,
        user: null,
        loading: false,
        blocked: true,
        token: null,
      };
    case GET_ME_FAILED:
      return { ...state, loading: false, token: null };
    case SET_SUMMARY_DATA:
      return { ...state, summary_data: action.payload };
    case SET_LOADING:
      return { ...state, loading: action.payload };
    default:
      return { ...state };
  }
};

export default Auth;
